import './home.scss';

import React from 'react';
import { Link } from 'react-router-dom';
import { Translate } from 'react-jhipster';
import { Row, Col, Alert } from 'reactstrap';

import { useAppSelector } from 'app/config/store';

export const Home = () => {
  const account = useAppSelector(state => state.authentication.account);

  return (
    <Row>
      <Col md="3" className="pad">
        <span className="hipster rounded" />
      </Col>
      <Col md="9">
        <h1 className="display-4">
          <Translate contentKey="home.title">Welcome, Java Hipster!</Translate>
        </h1>
        Pour essayer cet outil connectez vous en utilisant: <br />
        - ✅ login=user
        <br />- ✅ password=user
        <div className="home-intro container py-5">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1 className="display-4 fw-bold">AlexisExport</h1>
              <p className="lead mt-3">
                {/*
                        <Translate contentKey="home.subtitle">This is your homepage</Translate>
                       */}
                <span style={{ fontWeight: 'bold', fontStyle: 'italic', color: '#006400' }}>
                  AlexisExport est une Application web de gestion d'activité d'import-export.
                </span>
                <br />
                <br />
                C'est un outil qui vous permet d'organiser l'importation et l'exportation de produits exotiques et tropicaux entre l'Afrique
                et la France. Elle vous permet de suivre vos commandes, vos livraisons, vos stocks, vos devis et factures de manière
                efficace via une interface moderne.
              </p>
              <ul className="list-unstyled mt-4">
                <li>✅ Gestion complète des produits et commandes</li>
                <li>✅ Suivi des livraisons et stocks en temps réel</li>
                <li>✅ Emission de devis et de factures</li>
                <li>✅ API REST sécurisée pour intégration externe</li>
                <li>✅ Déploiement continu automatisé</li>
              </ul>
              <a href="/swagger-ui/" className="btn btn-primary mt-3">
                Découvrir l'API
              </a>
            </div>
            {/*             <div className="col-md-6 text-center">
              <img
                src="content/images/alexis-export-illustration.png"
                alt="Présentation alexisExport"
                className="img-fluid rounded shadow"
              />
            </div> */}
          </div>
        </div>
        {account?.login ? (
          <div>
            <Alert color="success">
              <Translate contentKey="home.logged.message" interpolate={{ username: account.login }}>
                You are logged in as user {account.login}.
              </Translate>
            </Alert>
          </div>
        ) : (
          <div>
            <Alert color="warning">
              {/* <Translate contentKey="global.messages.info.authenticated.prefix">If you want to </Translate>

              <Link to="/login" className="alert-link">
                <Translate contentKey="global.messages.info.authenticated.link"> sign in</Translate>
              </Link>
              <Translate contentKey="global.messages.info.authenticated.suffix">
                , you can try the default accounts:
                <br />- Administrator (login=&quot;admin&quot; and password=&quot;(your admin password)&quot;)
                <br />- User (login=&quot;user&quot; and password=&quot;user&quot;).
              </Translate> */}
            </Alert>

            <Alert color="warning">
              <Translate contentKey="global.messages.info.register.noaccount">You do not have an account yet?</Translate>&nbsp;
              <Link to="/account/register" className="alert-link">
                <Translate contentKey="global.messages.info.register.link">Register a new account</Translate>
              </Link>
            </Alert>
          </div>
        )}
        {/* <p>
          <Translate contentKey="home.question">If you have any question on JHipster:</Translate>
        </p> */}
        <ul>
          {/*  <li>
            <a href="https://www.jhipster.tech/" target="_blank" rel="noopener noreferrer">
              <Translate contentKey="home.link.homepage">JHipster homepage</Translate>
            </a>
          </li>
          <li>
            <a href="https://stackoverflow.com/tags/jhipster/info" target="_blank" rel="noopener noreferrer">
              <Translate contentKey="home.link.stackoverflow">JHipster on Stack Overflow</Translate>
            </a>
          </li>
          <li>
            <a href="https://github.com/jhipster/generator-jhipster/issues?state=open" target="_blank" rel="noopener noreferrer">
              <Translate contentKey="home.link.bugtracker">JHipster bug tracker</Translate>
            </a>
          </li>
          <li>
            <a href="https://gitter.im/jhipster/generator-jhipster" target="_blank" rel="noopener noreferrer">
              <Translate contentKey="home.link.chat">JHipster public chat room</Translate>
            </a>
          </li>
          <li>
            <a href="https://twitter.com/jhipster" target="_blank" rel="noopener noreferrer">
              <Translate contentKey="home.link.follow">follow @jhipster on Twitter</Translate>
            </a>
          </li> */}
        </ul>
        <p>
          {/* <Translate contentKey="home.like">If you like JHipster, do not forget to give us a star on</Translate>{' '}
          <a href="https://github.com/jhipster/generator-jhipster" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
          ! */}
        </p>
      </Col>
    </Row>
  );
};

export default Home;
